import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cssday1',
  templateUrl: './cssday1.component.html',
  styleUrls: ['./cssday1.component.css']
})
export class Cssday1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
